// reducer.js
import {
  FETCH_TICKETS_REQUEST,
  FETCH_FILTER_TICKETS_REQUEST,
  FETCH_TICKET_REQUEST,
  UPDATE_TICKET_TECHNICIAN_REQUEST,
  UPDATE_TICKET_STATUS_REQUEST,
  CREATE_TICKET_REQUEST,
  UPDATE_TICKET_REQUEST,
  CLOSE_TICKET_REQUEST,
  CREATE_TICKET_COMMENT_REQUEST,
  DELETE_TICKET_COMMENT_REQUEST,
  UPDATE_TICKET_MATERIAL_REQUEST,

  FETCH_TICKETS_SUCCESS,
  FETCH_FILTER_TICKETS_SUCCESS,
  FETCH_TICKET_SUCCESS,
  UPDATE_TICKET_TECHNICIAN_SUCCESS,
  UPDATE_TICKET_STATUS_SUCCESS,
  CREATE_TICKET_SUCCESS,
  UPDATE_TICKET_SUCCESS,
  CLOSE_TICKET_SUCCESS,
  CREATE_TICKET_COMMENT_SUCCESS,
  DELETE_TICKET_COMMENT_SUCCESS,
  UPDATE_TICKET_MATERIAL_SUCCESS,

  FETCH_TICKETS_FAILURE,
  FETCH_FILTER_TICKETS_FAILURE,
  FETCH_TICKET_FAILURE,
  UPDATE_TICKET_TECHNICIAN_FAILURE,
  UPDATE_TICKET_STATUS_FAILURE,
  CREATE_TICKET_FAILURE,
  UPDATE_TICKET_FAILURE,
  CLOSE_TICKET_FAILURE,
  CREATE_TICKET_COMMENT_FAILURE,
  DELETE_TICKET_COMMENT_FAILURE,
  UPDATE_TICKET_MATERIAL_FAILURE,
} from './actions';

const initialState = {
  tickets_data: null,
  filter_tickets_data: null,
  ticket_data: null,
  technician_data: null,
  status_data: null,
  isCreate: false,
  isUpdate: false,
  isClose: false,
  isCreateComment: false,
  isDeleteComment: false,
  isUpdateMaterial: false,
  loading: false,
  error: null,
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_FILTER_TICKETS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_TICKET_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_TICKET_TECHNICIAN_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_TICKET_STATUS_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_TICKET_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_TICKET_REQUEST:
      return { ...state, loading: true, error: null };
    case CLOSE_TICKET_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_TICKET_COMMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_TICKET_COMMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_TICKET_MATERIAL_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TICKETS_SUCCESS:
      return { ...state, loading: false, tickets_data: action.payload, data: action.payload };
    case FETCH_FILTER_TICKETS_SUCCESS:
      return { ...state, loading: false, filter_tickets_data: action.payload, data: action.payload };
    case FETCH_TICKET_SUCCESS:
      return { ...state, loading: false, ticket_data: action.payload };
    case UPDATE_TICKET_TECHNICIAN_SUCCESS:
      return { ...state, loading: false, technician_data: action.payload };
    case UPDATE_TICKET_STATUS_SUCCESS:
      return { ...state, loading: false, status_data: action.payload };
    case CREATE_TICKET_SUCCESS:
      return { ...state, loading: false, isCreate: action.payload };
    case UPDATE_TICKET_SUCCESS:
      return { ...state, loading: false, isUpdate: action.payload };
    case CLOSE_TICKET_SUCCESS:
      return { ...state, loading: false, isClose: action.payload };
    case CREATE_TICKET_COMMENT_SUCCESS:
      return { ...state, loading: false, isCreateComment: action.payload };
    case DELETE_TICKET_COMMENT_SUCCESS:
      return { ...state, loading: false, isDeleteComment: action.payload };
    case UPDATE_TICKET_MATERIAL_SUCCESS:
      return { ...state, loading: false, isUpdateMaterial: action.payload };

    case FETCH_TICKETS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_FILTER_TICKETS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_TICKET_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_TICKET_TECHNICIAN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_TICKET_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_TICKET_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_TICKET_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CLOSE_TICKET_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_TICKET_COMMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_TICKET_COMMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_TICKET_MATERIAL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default ticketReducer;
